import React, { useState, useEffect } from 'react';
import './Resume.css';
import { trackDownload, trackButtonClick } from '../utils/analytics';

const Resume = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showFallback, setShowFallback] = useState(false);
  
  // Replace this with your actual resume PDF URL
  const resumeUrl = `${process.env.PUBLIC_URL}/Manoj_Kumar_Eede_Resume.pdf`;
  // Try multiple PDF viewers
  const pdfViewers = [
    resumeUrl, // Direct PDF
    `https://docs.google.com/viewer?url=${encodeURIComponent(window.location.origin + process.env.PUBLIC_URL + '/Manoj_Kumar_Eede_Resume.pdf')}&embedded=true`,
    `https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(window.location.origin + process.env.PUBLIC_URL + '/Manoj_Kumar_Eede_Resume.pdf')}`
  ];
  const [currentViewerIndex, setCurrentViewerIndex] = useState(0);

  // Scroll to resume section on component mount
  useEffect(() => {
    const timer = setTimeout(() => {
      const resumeElement = document.getElementById('resume');
      if (resumeElement) {
        resumeElement.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleDownload = () => {
    trackDownload('Resume_ManojKumarEede.pdf', 'PDF');
    trackButtonClick('Download Resume', 'Resume');
    
    const link = document.createElement('a');
    link.href = resumeUrl;
    link.download = 'Resume_ManojKumarEede.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleOpenNewTab = () => {
    trackButtonClick('Open Resume in New Tab', 'Resume');
    
    // Construct absolute URL to bypass React Router
    const absolutePdfUrl = `${window.location.protocol}//${window.location.host}${process.env.PUBLIC_URL}/Manoj_Kumar_Eede_Resume.pdf`;
    
    // Use window.open with absolute URL
    window.open(absolutePdfUrl, '_blank', 'noopener,noreferrer');
  };

  const handleFrameLoad = () => {
    setIsLoading(false);
  };

  const handleFrameError = () => {
    setIsLoading(false);
    if (currentViewerIndex < pdfViewers.length - 1) {
      setCurrentViewerIndex(currentViewerIndex + 1);
      setIsLoading(true);
    } else {
      setShowFallback(true);
    }
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="resume" className="resume section">
      <div className="container">
        <h2 className="section-title">My Resume</h2>
        <p className="section-subtitle">
          Download or view my complete resume with detailed information about my experience and skills
        </p>

        <div className="resume-actions">
          <button onClick={handleDownload} className="btn-primary download-btn">
            <i className="fas fa-download"></i>
            Download PDF
          </button>
          <button onClick={handleOpenNewTab} className="btn-secondary">
            <i className="fas fa-external-link-alt"></i>
            Open in New Tab
          </button>
        </div>


        <div className="resume-container">
          {isLoading && (
            <div className="resume-loading">
              <div className="loading-spinner"></div>
              <p>Loading resume...</p>
            </div>
          )}
          
          {!showFallback ? (
            <div className="resume-viewer">
              <iframe
                src={pdfViewers[currentViewerIndex]}
                title="Resume"
                onLoad={handleFrameLoad}
                onError={handleFrameError}
                className={`resume-iframe ${isLoading ? 'loading' : ''}`}
              />
            </div>
          ) : (
            <div className="resume-fallback">
              <div className="fallback-content">
                <i className="fas fa-file-pdf"></i>
                <h3>Resume Preview</h3>
                <p>The PDF preview couldn't load in your browser. You can download the resume directly or view it in a new tab.</p>
                <div className="fallback-actions">
                  <button onClick={handleDownload} className="btn-primary">
                    <i className="fas fa-download"></i>
                    Download Resume
                  </button>
                  <button onClick={handleOpenNewTab} className="btn-secondary">
                    <i className="fas fa-external-link-alt"></i>
                    Open in New Tab
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Resume; 